import React, { lazy, Suspense } from "react"
import { observer } from "mobx-react"
import { Flex, Image, Spin, Typography } from "antd"

import s from "../index.module.css"

export type OnboardingStepComponentWrapProps = {
  children: React.ReactNode
  pic?: string
  subtitle?: string

  title: string
}

export const OnboardingStepComponentWrap = observer(
  ({ children, pic, subtitle, title }: OnboardingStepComponentWrapProps) => {
    const LazyImage = ({ src }: { src: string }) => {
      const ImageComponent = lazy(() =>
        import(`/src/app/assets/onboarding/${src}.svg`).then((module) => ({
          default: () => (
            <Image
              height={120}
              preview={false}
              src={module.default}
              width={120}
            />
          ),
        })),
      )

      return (
        <Suspense
          fallback={
            <div style={{ height: 120, width: 120 }}>
              <Spin size={"small"}></Spin>
            </div>
          }
        >
          <ImageComponent />
        </Suspense>
      )
    }

    return (
      <Flex gap={12} vertical>
        {pic ? <LazyImage src={pic} /> : null}
        <Flex gap={4} vertical>
          <Typography.Title className={s.stepTitle} level={3}>
            {title}
          </Typography.Title>
          <Typography.Text className={s.stepSubTitle}>
            {subtitle}
          </Typography.Text>
        </Flex>

        <Flex className={s.content} vertical>
          {children}
        </Flex>
      </Flex>
    )
  },
)
